import * as React from 'react';
import {
  IUIUrval,
  TEDInputUrvalType,
  TEDUrvalVisibility,
} from '../../../../../../Types/UrvalTypes';
import {
  IFormValues,
  IWarnings,
  IFormActions,
} from '../../../../../../Types/FormTypes';
import SaveUrvalForm from '../_Common/SaveUrvalForm';
import Logger from '../../../../../../Utils/Logger';

interface IProps {
  setOKClick: (okClick: any) => void;
  saveNewUrval: (
    urval: IUIUrval,
    inputUrval: TEDInputUrvalType
  ) => Promise<void>;
  urval: IUIUrval;
  collectionName: string;
  userId?: string;
  rutinId: number;
  onSuccess: () => void;
  kodplanID?: string;
  setError?: (error: boolean) => void;
  usageCode?: string;
  availableVisibilityOptions: TEDUrvalVisibility[];
}

class SaveNewUrvalForm extends React.Component<IProps> {
  handleSubmit = (
    values: IFormValues,
    warnings: IWarnings,
    formActions: IFormActions
  ) => {
    const inputUrval: TEDInputUrvalType = {
      namn: values.name as string,
      beskrivning: values.description as string,
      synlighet: values.visibility as TEDUrvalVisibility,
      synligAnvID: this.props.userId,
      rutinID: this.props.rutinId,
      collection: this.props.collectionName,
      kontoplanID: this.props.kodplanID,
      usagecode: this.props.usageCode,
    };

    this.props
      .saveNewUrval(this.props.urval, inputUrval)
      .then(() => {
        if (this.props.onSuccess != null) {
          this.props.onSuccess();
        }
      })
      .catch(reason => {
        Logger.error(reason);
      });
  };

  render() {
    return (
      <SaveUrvalForm
        setOKClick={this.props.setOKClick}
        onSubmit={this.handleSubmit}
        availableVisibilityOptions={this.props.availableVisibilityOptions}
        initialValues={{
          name: '',
          visibility: this.props.availableVisibilityOptions[0]
            ? this.props.availableVisibilityOptions[0]
            : null,
          description: null,
        }}
        setError={this.props.setError}
      />
    );
  }
}

export default SaveNewUrvalForm;
